"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCatalogsToVariantsItems = exports.mapCatalogsToVariantsItem = void 0;
const groupBy_1 = __importDefault(require("lodash/fp/groupBy"));
const map_1 = __importDefault(require("lodash/fp/map"));
const pipe_1 = __importDefault(require("lodash/fp/pipe"));
const sortCatalogs_1 = require("./sortCatalogs");
function mapCatalogsToVariantsItem(catalogs) {
    const items = catalogs.slice(0);
    return Object.assign(Object.assign({}, items[0]), { variants: items });
}
exports.mapCatalogsToVariantsItem = mapCatalogsToVariantsItem;
const groupCatalogsById = (0, groupBy_1.default)(catalog => (0, sortCatalogs_1.splitCatalogId)(catalog.id));
const mapCatalogGroupToItems = (0, map_1.default)(mapCatalogsToVariantsItem);
exports.mapCatalogsToVariantsItems = (0, pipe_1.default)(sortCatalogs_1.sortCatalogs, groupCatalogsById, mapCatalogGroupToItems);
//# sourceMappingURL=mapCatalogsToVariantsItems.js.map